import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "pt-4 overflow-auto" }
const _hoisted_2 = { class: "bg-grey-lighten-3" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "text-black font-weight-medium" }
const _hoisted_5 = { class: "bg-grey-lighten-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_table = _resolveComponent("v-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _cache[14] || (_cache[14] = _createElementVNode("h2", { class: "text-h5 mb-4 text-black font-weight-bold" }, "売上情報", -1)),
    _createVNode(_component_v_card, {
      color: "grey-lighten-5",
      class: "mt-2",
      variant: "outlined"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_container, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_col, {
                  cols: "12",
                  md: "3"
                }, {
                  default: _withCtx(() => [
                    _cache[3] || (_cache[3] = _createElementVNode("h5", { class: "text-subtitle-2 mb-1 text-black" }, "施設名", -1)),
                    _createVNode(_component_v_select, {
                      modelValue: _ctx.searchFilter.nurseryId,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchFilter.nurseryId) = $event)),
                      items: _ctx.nurseries,
                      "item-title": "nurseryName",
                      "item-value": "nurseryId",
                      variant: "outlined",
                      density: "compact",
                      "hide-details": "",
                      "bg-color": "white"
                    }, null, 8, ["modelValue", "items"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "12",
                  md: "3"
                }, {
                  default: _withCtx(() => [
                    _cache[4] || (_cache[4] = _createElementVNode("h5", { class: "text-subtitle-2 mb-1 text-black" }, "開始月", -1)),
                    _createVNode(_component_v_text_field, {
                      modelValue: _ctx.searchFilter.monthFrom,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchFilter.monthFrom) = $event)),
                      type: "month",
                      variant: "outlined",
                      density: "compact",
                      "hide-details": "",
                      "bg-color": "white",
                      class: "date-input-custom"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "12",
                  md: "3"
                }, {
                  default: _withCtx(() => [
                    _cache[5] || (_cache[5] = _createElementVNode("h5", { class: "text-subtitle-2 mb-1 text-black" }, "終了月", -1)),
                    _createVNode(_component_v_text_field, {
                      modelValue: _ctx.searchFilter.monthTo,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchFilter.monthTo) = $event)),
                      type: "month",
                      variant: "outlined",
                      density: "compact",
                      "hide-details": "",
                      clearable: "",
                      "bg-color": "white",
                      class: "date-input-custom"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_spacer)
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_col, {
                  cols: "12",
                  md: "4"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      onClick: _ctx.listSales,
                      loading: _ctx.loading,
                      color: "primary",
                      variant: "elevated",
                      block: ""
                    }, {
                      default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                        _createTextVNode(" 検索 ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["onClick", "loading"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_spacer)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_v_table, { class: "border text-black" }, {
        default: _withCtx(() => [
          _createElementVNode("thead", _hoisted_2, [
            _createElementVNode("tr", null, [
              _cache[7] || (_cache[7] = _createElementVNode("th", { class: "text-left text-black font-weight-bold" }, "項目名", -1)),
              _cache[8] || (_cache[8] = _createElementVNode("th", { class: "text-left text-black font-weight-bold" }, null, -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sales, (item, i) => {
                return (_openBlock(), _createElementBlock("th", {
                  key: i,
                  class: "text-center text-black font-weight-bold"
                }, _toDisplayString(`${item.year}/${item.month}`), 1))
              }), 128))
            ])
          ]),
          (_ctx.sales && _ctx.sales.length > 0)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rowConfigs, (config) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: config.label
                  }, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", _hoisted_4, _toDisplayString(config.label), 1),
                      _cache[9] || (_cache[9] = _createElementVNode("td", { class: "text-black" }, "アップロード数", -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sales, (item, i) => {
                        return (_openBlock(), _createElementBlock("td", {
                          key: i,
                          class: "text-center text-black"
                        }, _toDisplayString(_ctx.getSaleData(item, config.cat, config.fmt)?.unitOfUpload ?? 0), 1))
                      }), 128))
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[10] || (_cache[10] = _createElementVNode("td", null, null, -1)),
                      _cache[11] || (_cache[11] = _createElementVNode("td", { class: "text-black" }, "売上本数", -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sales, (item, i) => {
                        return (_openBlock(), _createElementBlock("td", {
                          key: i,
                          class: "text-center text-black"
                        }, _toDisplayString(_ctx.getSaleData(item, config.cat, config.fmt)?.unitOfSales ?? 0), 1))
                      }), 128))
                    ]),
                    _createElementVNode("tr", _hoisted_5, [
                      _cache[12] || (_cache[12] = _createElementVNode("td", null, null, -1)),
                      _cache[13] || (_cache[13] = _createElementVNode("td", { class: "text-black" }, "売上金額", -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sales, (item, i) => {
                        return (_openBlock(), _createElementBlock("td", {
                          key: i,
                          class: "text-center"
                        }, [
                          _createElementVNode("strong", null, _toDisplayString((_ctx.getSaleData(item, config.cat, config.fmt)?.price ?? 0).toLocaleString()) + "円 ", 1)
                        ]))
                      }), 128))
                    ])
                  ], 64))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ])
  ]))
}